import { useMemo, useState } from 'react';
import { useAccessibleThemes } from '@/lib/themes/themes-queries';
import { ThemeCard } from '@/components/themes/theme-card';
import { SCHOOL_LEVELS } from '@jeraisonne/db';
import type { SchoolLevel } from '@jeraisonne/db';

export function ThemesIndexPage() {
  const [search, setSearch] = useState('');
  const [level, setLevel] = useState<SchoolLevel | ''>('');

  const filters = useMemo(() => ({ minLevel: level || null, search }), [level, search]);

  const { data: themes = [], isLoading } = useAccessibleThemes(filters);

  return (
    <div className="mx-auto w-full max-w-3xl px-4 py-6 sm:py-8">
      <header className="mb-5 flex flex-col gap-2">
        <h1 className="font-display text-ink-900 text-[24px] font-bold">Thèmes</h1>
        <p className="text-ink-500 font-sans text-[14px]">
          Explore les exercices par contexte : sociétés, élections, écologie, jeux…
        </p>
      </header>

      <div className="mb-4 flex flex-col gap-2 sm:flex-row">
        <input
          type="search"
          inputMode="search"
          placeholder="Rechercher un thème…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="border-ink-200 focus:border-primary-500 min-h-[2.75rem] w-full rounded-xl border bg-white px-4 py-2 text-sm outline-none"
        />
        <select
          value={level}
          onChange={(e) => setLevel(e.target.value as SchoolLevel | '')}
          className="border-ink-200 focus:border-primary-500 min-h-[2.75rem] w-full rounded-xl border bg-white px-4 py-2 text-sm outline-none sm:w-44"
        >
          <option value="">Tous niveaux</option>
          {SCHOOL_LEVELS.map((l) => (
            <option key={l.value} value={l.value}>
              {l.label}
            </option>
          ))}
        </select>
      </div>

      {isLoading ? (
        <p className="text-ink-500 text-sm">Chargement…</p>
      ) : themes.length === 0 ? (
        <p className="text-ink-500 text-sm">Aucun thème ne correspond à ta recherche.</p>
      ) : (
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {themes.map((t) => (
            <ThemeCard key={t.id} theme={t} to={`/themes/${t.slug}`} />
          ))}
        </div>
      )}
    </div>
  );
}
